import { Dispatch, SetStateAction } from 'react';
import { IFRAME_LANGUAGES } from './App';

interface Props {
  selectedLanguage: string;
  setSelectedLanguage: Dispatch<SetStateAction<string>>;
}

function LanguageSelector({ selectedLanguage, setSelectedLanguage }: Props) {
  return (
    <select value={selectedLanguage} onChange={(event) => setSelectedLanguage(event.target.value)}>
      {IFRAME_LANGUAGES.map((lang) => (
        <option key={lang} value={lang}>
          {lang}
        </option>
      ))}
    </select>
  );
}

export default LanguageSelector;
